module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-button', {
    staticClass: "upload",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loading
    }
  }, [_vm._v("上传文件")]), _vm._v(" "), (_vm.uploadShow) ? _c('mt-progress', {
    attrs: {
      "value": _vm.value,
      "bar-height": 3
    }
  }, [_c('div', {
    slot: "end"
  }, [_vm._v(_vm._s(_vm.value) + "%")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45b2907f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progressbar.vue
// module id = 106
// module chunks = 0